import { azureKeyVaultSecretsPlugin } from './plugin';

export { azureKeyVaultSecretsPlugin };

/**
 * The default export is what the app's feature discovery (`app.packages` in
 * `app-config.yaml`) installs.
 */
export default azureKeyVaultSecretsPlugin;
